export default "__VITE_ASSET__DK32JKVd__"